<div bsModal #modelManipulate="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog">
        <div class="modal-content">
            <form (ngSubmit)="save()" #modelForm="ngForm">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="close()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">{{ edit ? 'Edit Model &bull; ' + model.Name : 'Create Model' }}</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="control-group input-group-addon" for="NewModelName">Model Name</label>
                                <input #modelNameControl="ngModel" id="NewModelName" name="NewModelName" type="text" class="form-control" placeholder="Model Name" required [(ngModel)]="model.Name" [ngClass]="{ 'has-error' : !modelNameControl.valid }" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group input-group has-feedback">
                                <label class="input-group-addon">Classification</label>
                                <select #classificationControl="ngModel" name="selectedClassification" class="form-control" required [(ngModel)]="model.ClassificationId" [ngClass]="{ 'has-error' : !classificationControl.valid }">
                                    <option [selected]="!edit || model.ClassificationId == null">--- Select a Classification ---</option>
                                    <option *ngFor="let classification of classifications" [value]="classification.Id" [selected]="model.ClassificationId === classification.Id.toString()">{{ classification.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" *ngIf="!edit" class="pull-left btn btn-default" [disabled]="!modelForm.form.valid" (click)="save(true)">Create and Add Another</button>
                    <button type="button" class="btn btn-default" (click)="close()">Close</button>
                    <button type="submit" class="btn btn-primary" [disabled]="!modelForm.form.valid">{{ edit ? 'Save' : 'Create' }}</button>
                </div>
            </form>
        </div>
    </div>
</div>
